import React, { Component, Fragment } from 'react';
import { Modal, ModalHeader, Button } from 'reactstrap';
import closeRed from 'images/close-red.svg';

class DeleteDomainModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }

  render() {
    const { showModal, handleDelete, closeModal } = this.props;
    return (
      <Fragment>
        <Modal isOpen={showModal} className="delete-modal">
          <div className="delete-modal__content">
            <div className="delete-modal__top">
              <div className="h3-title delete-modal__title">
                Delete domain forever?
              </div>
              <div className="delete-modal__subtitle">
                It will be deleted permanently and coudn’t be restored. All data
                will be lost.
              </div>
            </div>
            <div className="delete-modal__descr">
              <div className="delete-modal__list">
                <div className="mark-itm">
                  <div className="mark-itm__icon">
                    <img src={closeRed} alt="danger" />
                  </div>
                  <div className="mark-itm__text">
                    Domain will be unaccessible
                  </div>
                </div>
                <div className="mark-itm">
                  <div className="mark-itm__icon">
                    <img src={closeRed} alt="danger" />
                  </div>
                  <div className="mark-itm__text">
                    All statistics will be lost
                  </div>
                </div>
              </div>
              <div className="separator-line" />
            </div>
            <div className="delete-modal__btn">
              <Button
                className="dtn btn-red modal-btn-width"
                onClick={handleDelete}>
                Yes, delete forever
              </Button>
              <Button
                color="blue"
                className="dtn btn-red outline modal-btn-width"
                onClick={closeModal}>
                Cancel, do not delete
              </Button>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

export default DeleteDomainModal;



// WEBPACK FOOTER //
// ./src/components/DomainCard/DeleteDomainModal.js